export default {
    url: '/schedule',
    template: `
        <courses-courses-edit-occurrence-add-schedule
            course="vm.course"
            occurrence="vm.occurrence"
            occurrence-trainings="vm.occurrenceTrainings"
            trainers="vm.trainers"
            rooms="vm.rooms"
            participants="vm.participants"
            training-companies="vm.trainingCompanies"
            training-times-with-participants="vm.trainingTimesWithParticipants"
            course-version="vm.courseVersion"
        />
    `,
    resolve: {
        occurrence (OccurrenceResource, $stateParams) {
            return OccurrenceResource.get({ id: $stateParams.occurrenceId, expand: 'courseOccurrenceParticipants,courseVersion,courseOccurrenceLanguages,courseOccurrenceManagers,sites' }).$promise;
        },
        occurrenceTrainings (OccurrenceResource, $stateParams) {
            return OccurrenceResource.getTrainings({ id: $stateParams.occurrenceId }).$promise;
        },
        participants (OccurrenceResource, $stateParams) {
            return OccurrenceResource.getParticipants(
                { pageSize: 0, privilegesCheck: 0 },
                { occurrenceId: $stateParams.occurrenceId }
            ).$promise;
        },
        trainingCompanies (TrainingCompanyResource) {
            return TrainingCompanyResource.query({ pageSize: 0 }).$promise;
        },
        trainingTimesWithParticipants (OccurrenceResource, $stateParams) {
            return OccurrenceResource.getTrainingTimeParticipants({
                occurrenceId: $stateParams.occurrenceId,
                expand: 'courseOccurrenceTrainingTimeParticipants'
            }).$promise;
        },
        trainers (UserResource, ROLE_CODE_ENUM) {
            return UserResource.query({ roleCode: ROLE_CODE_ENUM.KEYS.TRAINER, pageSize: 0, privilegesCheck: 0 }).$promise;
        },
        courseVersion (CourseVersionResource, occurrence) {
            return CourseVersionResource.get({ id: occurrence.courseVersionId, expand: 'courseTrainings' }).$promise;
        }
    },
    controller ($scope, trainers, occurrence, occurrenceTrainings, participants,
                trainingTimesWithParticipants, trainingCompanies, courseVersion,
                OccurrenceService, MomentService) {
        this.$scope = $scope;
        this.trainers = trainers;
        $scope.$parent.vm.step = 3;
        $scope.$parent.vm.occurrence = occurrence;
        $scope.$parent.vm.canManageOccurrences = !OccurrenceService.isReadonlyOccurrence(occurrence);
        this.occurrence = occurrence;
        this.course = $scope.$parent.vm.course;
        this.trainingCompanies = trainingCompanies;
        this.rooms = $scope.$parent.vm.rooms;
        this.occurrenceTrainings = occurrenceTrainings;
        this.participants = participants;
        this.trainingTimesWithParticipants = trainingTimesWithParticipants;
        this.courseVersion = courseVersion;

        if (this.occurrence.displayUntil) {
            this.occurrence.displayUntil = MomentService.formatTimeStamp(this.occurrence.displayUntil, 'YYYY-MM-DD HH:mm:ss', true);
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/courses/edit/occurrence/add/schedule/index.js